import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { CommonSearchParam } from '../models/common-search-param.model';
import { DeveloperService } from './developer.service';

@Injectable({ providedIn: 'root' })
export class SearchParamManagerService {

  readonly allClearHanler = new ReplaySubject<void>();

  /**
   * ルートの変更を通知
   */
  notifyAllClear() { this.allClearHanler.next(); }
}

@Injectable({ providedIn: 'root' })
export abstract class CommonSearchParamService<T extends CommonSearchParam> {

  public readonly items$ = new BehaviorSubject<T>(this.default());

  protected abstract default(): T;

  constructor(
    scnService: SearchParamManagerService,
    protected developerService: DeveloperService
  ) {
    scnService.allClearHanler.subscribe(_ => this.clear());
  }

  setItems(items: T) { this.items$.next(items); }

  clear() { this.items$.next(this.default()); }
}
